import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ClientGaraje } from 'src/app/interfaces/clientGaraje';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage/storage.service';

declare var google;

@Component({
  selector: 'app-clientes',
  templateUrl: './garaje.page.html',
  styleUrls: ['./garaje.page.scss'],
})
export class GarajePage implements OnInit {

  name: string;
  dni: string;
  userRole: any;
  currentPage = 0;
  maxPage = 0;
  limit = 50;

  getTipoPlaza(tPlaza: number){
    switch (tPlaza) {
      case 1:
        return "Pequeña";
        break;

      case 2:
        return "Grande";
        break;

      case 3:
      return "Moto";
      break;

      case 4:
      return "Grande+Moto";
      break;
    
      default:
        return "Tipo de plaza";
        break;
    }
  }

  columns = [
    {
      field: 'id',
      name: 'id',
      width: 5
    },
    {
      field: 'nombre',
      name: 'Nombre',
      width: 10
    },
    {
      field: 'dni',
      name: 'dni',
      width: 10
    },
    {
      field: 'email',
      name: 'correo',
      width: 15
    },
    {
      field: 'tPlaza',
      name: 'Tipo de plaza',
      width: 5,
      type: 'tPlazaValue',
      tPlazaValues: {
        1:'Pequeña',
        2:'Grande',
        3:'Moto',
        4:'Grande+Moto',
        5:'Trastero'
      }
    },
    {
      field: 'price',
      name: 'Precio €/mes',
      width: 5
    },
    {
      field: 'isActive',
      name: 'Cliente Activo',
      width: 5,
      type: 'boolean',
      bolValues: {
        true: 'Sí',
        false: 'No'
      }
    },
    {
      field: 'action',
      name: 'acciones rápidas',
      width: 20,
      actions: [
        {
          type: 'delete'
        },
        {
          type: 'edit'
        },
        {
          type: 'factura'
        }
        // {
        //   type: 'call',
        //   validate: 'contact'
        // },
        // {
        //   type: 'location',
        //   validate: 'address'
        // }
      ]
    }
  ];

  lines: ClientGaraje[];
  searchMode = false;

  constructor(private alert: AlertController,
    private rest: RestService,
    private utils: UtilsService,
    private router: Router,
    private storage: StorageService
  ) { }

  async ionViewWillEnter() {
    await this.utils.showLoading();
    this.getUserInfo();
    this.getClientsGaraje();
    console.log(this.lines);
    await this.utils.hideLoading();
  }

  ngOnInit() { }

  async getUserInfo() {
    const result = await this.storage.getUser();
    this.userRole = result.role;
  }

  async getClientsGaraje() {
    this.searchMode = false;
    const resp = await this.rest.getClientsGaraje(this.currentPage + 1, this.limit);
    console.log(resp);
    
    this.maxPage = Math.ceil((resp.body.total / this.limit) + ((resp.body.total % this.limit > 0) ? 1 : 0));
    this.lines = resp.body.records;
  }

  
  async search() {
    this.searchMode = true;
    try {
      await this.utils.showLoading();
      console.log('Search this');
      let resp;
      if (!this.name && !this.dni) {
        resp = await this.rest.getClientsGaraje();
        this.maxPage = Math.ceil((resp.body.total / 50) + ((resp.body.total % 50 > 0) ? 1 : 0));
      } else {
        resp = await this.rest.getClientsGarajeByNameDocument(this.currentPage + 1, 50, this.name, this.dni);
        console.log(resp)
        this.maxPage = Math.ceil((resp.body.total / 50) + ((resp.body.total % 50 > 0) ? 1 : 0));
      }
      console.log(resp);
      this.lines = resp.body.records;
      await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error cargando clientes', 'danger', 3000);
    }
    // this.currentPage = 0;
  }

  async doAction(data) {
    console.log(data);
    const line: ClientGaraje = data.line;
    if (data.action === 'delete') {
      this.deleteItem(line.id, line._id);
    }
    if (data.action === 'edit') {
      this.router.navigateByUrl(`/garaje/${line._id}`);
    }
    if (data.action === 'factura') {
      this.openAlertNewBill(line);
      //this.generalClientInvoice(line);
    }
    // if (data.action === 'call') {
    //   const showData = line.contact.map(contact => `${contact.name} - ${contact.value}`).join('<br>');
    //   this.utils.showAlertOnlyButtonOk('Contactos', '', showData);
    // }
    // if (data.action === 'location') {
    //   console.log('location');
    //   const showData = line.address.map(address => `${address.name} - ${address.value}`).join('<br>');
    //   this.utils.showAlertOnlyButtonOk('Direcciones', '', showData);
    // }
  }


  async openAlertMonthYear() {
    const alert = await this.alert.create({
      header: 'Elija mes y año',
      inputs: [
        {
          name: 'month',
          type: 'number',
          placeholder: 'Mes',
          value: new Date().getMonth() + 1
        },
        {
          name: 'year',
          type: 'number',
          placeholder: 'Año',
          value: new Date().getFullYear()
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Descargar ZIP',
          handler: async (data) => {
            console.log('data');
            console.log(data);
            await this.utils.showLoading('Cargando...', 4*60000);
            const resp: any = await this.rest.downloadFacturasByMonthYearGarajes(data);
            // console.log(resp.body);
            await this.utils.hideLoading();
          }
        },
        // {
        //   text: 'Descargar Excel',
        //   handler: async (data) => {
        //     console.log('data');
        //     console.log(data);
        //     await this.utils.showLoading();
        //     const resp: any = await this.rest.downloadExcelByMonthYearGarajes(data);
        //     // const resp: any = await this.rest.getListByMonth(data.year, data.month);
        //     // this.session.createMonthFacturas(resp.body, data.year, data.month);
        //     console.log(resp.body);
        //     await this.utils.hideLoading();
        //   }
        // }
      ]
    });
    await alert.present();
  }

  async openAlertNewBill(line: ClientGaraje) {
    const alert = await this.alert.create({
      header: "Generar factura para "+ line.nombre,
      inputs: [
        {
          name: 'price',
          type: 'number',
          label: "Importe",
          placeholder: 'Importe',
          value: line.price
        },
        {
          name: 'date',
          type: 'date',
          label: "Fecha",
          placeholder: 'Fecha',
          value: new Date().toISOString().split('T')[0]
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Generar factura',
          handler: async (data) => {
            console.log('data');
            console.log(data);
            await this.utils.showLoading('Cargando...', 4*60000);
            const resp: any = await this.generateFacturaGaraje(line, data);
            // console.log(resp.body);
            await this.utils.hideLoading();
          }
        }
      ]
    });
    await alert.present();
  }


  private formattedCurrentDate(): string {
    const today = new Date();
    
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();
  
    return `${day}-${month}-${year}`;
  }

  private formattedCurrentMonth(): string {
    const today = new Date();
    
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    
    return `${month}`;
  }

  private formattedCurrentDay(): string {
    const today = new Date();
    
    const day = today.getDate().toString().padStart(2, '0');
  
    return `${day}`;
  }

  private formattedCurrentYear(): string {
    const today = new Date();
    
    const year = today.getFullYear().toString();
  
    return `${year}`;
  }

  generalClientInvoice(cliente:ClientGaraje) {
    // let bi = reservation.total_price - reservation.total_price * 0.1;
    let currentDate = this.formattedCurrentDate()
    let currentDay= this.formattedCurrentDay()
    let currentMonth = this.formattedCurrentMonth()
    let currentYear = this.formattedCurrentYear()
    const htmlContent = `
      <style>
      /*
      ! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
      */
      
      /*
      1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
      2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
      */
      
      *,
      ::before,
      ::after {
        box-sizing: border-box;
        /* 1 */
        border-width: 0;
        /* 2 */
        border-style: solid;
        /* 2 */
        border-color: #e5e7eb;
        /* 2 */
      }
      
      ::before,
      ::after {
        --tw-content: '';
      }
      
      html {
        line-height: 1.5;
        /* 1 */
        -webkit-text-size-adjust: 100%;
        /* 2 */
        -moz-tab-size: 4;
        /* 3 */
        tab-size: 4;
        /* 3 */
        font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        /* 4 */
        font-feature-settings: normal;
        /* 5 */
        font-variation-settings: normal;
        /* 6 */
      }
      
      body {
        margin: 0;
        /* 1 */
        line-height: inherit;
        /* 2 */
      }
      
      /*
      1. Add the correct height in Firefox.
      2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
      3. Ensure horizontal rules are visible by default.
      */
      
      hr {
        height: 0;
        /* 1 */
        color: inherit;
        /* 2 */
        border-top-width: 1px;
        /* 3 */
      }
      
      /*
      Add the correct text decoration in Chrome, Edge, and Safari.
      */
      
      abbr:where([title]) {
        -webkit-text-decoration: underline dotted;
                text-decoration: underline dotted;
      }
      
      /*
      Remove the default font size and weight for headings.
      */
      
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-size: inherit;
        font-weight: inherit;
      }
      
      /*
      Reset links to optimize for opt-in styling instead of opt-out.
      */
      
      a {
        color: inherit;
        text-decoration: inherit;
      }
      
      /*
      Add the correct font weight in Edge and Safari.
      */
      
      b,
      strong {
        font-weight: bolder;
      }
      
      code,
      kbd,
      samp,
      pre {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
        /* 1 */
        font-size: 1em;
        /* 2 */
      }

      small {
        font-size: 80%;
      }
      
      sub,
      sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }
      
      sub {
        bottom: -0.25em;
      }
      
      sup {
        top: -0.5em;
      }
      
      /*
      1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
      2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
      3. Remove gaps between table borders by default.
      */
      
      table {
        text-indent: 0;
        /* 1 */
        border-color: inherit;
        /* 2 */
        border-collapse: collapse;
        /* 3 */
      }
      
      /*
      1. Change the font styles in all browsers.
      2. Remove the margin in Firefox and Safari.
      3. Remove default padding in all browsers.
      */
      
      button,
      input,
      optgroup,
      select,
      textarea {
        font-family: inherit;
        /* 1 */
        font-feature-settings: inherit;
        /* 1 */
        font-variation-settings: inherit;
        /* 1 */
        font-size: 100%;
        /* 1 */
        font-weight: inherit;
        /* 1 */
        line-height: inherit;
        /* 1 */
        color: inherit;
        /* 1 */
        margin: 0;
        /* 2 */
        padding: 0;
        /* 3 */
      }
      
      /*
      Remove the inheritance of text transform in Edge and Firefox.
      */
      
      button,
      select {
        text-transform: none;
      }
      
      /*
      1. Correct the inability to style clickable types in iOS and Safari.
      2. Remove default button styles.
      */
      
      button,
      [type='button'],
      [type='reset'],
      [type='submit'] {
        -webkit-appearance: button;
        /* 1 */
        background-color: transparent;
        /* 2 */
        background-image: none;
        /* 2 */
      }
      
      /*
      Use the modern Firefox focus style for all focusable elements.
      */
      
      :-moz-focusring {
        outline: auto;
      }
      
      :-moz-ui-invalid {
        box-shadow: none;
      }
      
      /*
      Add the correct vertical alignment in Chrome and Firefox.
      */
      
      progress {
        vertical-align: baseline;
      }
      
      /*
      Correct the cursor style of increment and decrement buttons in Safari.
      */
      
      ::-webkit-inner-spin-button,
      ::-webkit-outer-spin-button {
        height: auto;
      }
      
      /*
      1. Correct the odd appearance in Chrome and Safari.
      2. Correct the outline style in Safari.
      */
      
      [type='search'] {
        -webkit-appearance: textfield;
        /* 1 */
        outline-offset: -2px;
        /* 2 */
      }
      
      /*
      Remove the inner padding in Chrome and Safari on macOS.
      */
      
      ::-webkit-search-decoration {
        -webkit-appearance: none;
      }
      
      ::-webkit-file-upload-button {
        -webkit-appearance: button;
        /* 1 */
        font: inherit;
        /* 2 */
      }
      
      /*
      Add the correct display in Chrome and Safari.
      */
      
      summary {
        display: list-item;
      }
      
      /*
      Removes the default spacing and border for appropriate elements.
      */
      
      blockquote,
      dl,
      dd,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      hr,
      figure,
      p,
      pre {
        margin: 0;
      }
      
      fieldset {
        margin: 0;
        padding: 0;
      }
      
      legend {
        padding: 0;
      }
      
      ol,
      ul,
      menu {
        list-style: none;
        margin: 0;
        padding: 0;
      }
      
      /*
      Reset default styling for dialogs.
      */
      
      dialog {
        padding: 0;
      }
      
      /*
      Prevent resizing textareas horizontally by default.
      */
      
      textarea {
        resize: vertical;
      }
      
      /*
      1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
      2. Set the default placeholder color to the user's configured gray 400 color.
      */
      
      input::placeholder,
      textarea::placeholder {
        opacity: 1;
        /* 1 */
        color: #9ca3af;
        /* 2 */
      }
      
      /*
      Set the default cursor for buttons.
      */
      
      button,
      [role="button"] {
        cursor: pointer;
      }
      
      /*
      Make sure disabled buttons don't get the pointer cursor.
      */
      
      :disabled {
        cursor: default;
      }
      
      img,
      svg,
      video,
      canvas,
      audio,
      iframe,
      embed,
      object {
        display: block;
        /* 1 */
        vertical-align: middle;
        /* 2 */
      }
      
      /*
      Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
      */
      
      img,
      video {
        max-width: 100%;
        height: auto;
      }
      
      /* Make elements with the HTML hidden attribute stay hidden by default */
      
      [hidden] {
        visibility: hidden; border: none
      }
      
      *, ::before, ::after{
        --tw-border-spacing-x: 0;
        --tw-border-spacing-y: 0;
        --tw-translate-x: 0;
        --tw-translate-y: 0;
        --tw-rotate: 0;
        --tw-skew-x: 0;
        --tw-skew-y: 0;
        --tw-scale-x: 1;
        --tw-scale-y: 1;
        --tw-pan-x:  ;
        --tw-pan-y:  ;
        --tw-pinch-zoom:  ;
        --tw-scroll-snap-strictness: proximity;
        --tw-gradient-from-position:  ;
        --tw-gradient-via-position:  ;
        --tw-gradient-to-position:  ;
        --tw-ordinal:  ;
        --tw-slashed-zero:  ;
        --tw-numeric-figure:  ;
        --tw-numeric-spacing:  ;
        --tw-numeric-fraction:  ;
        --tw-ring-inset:  ;
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-color: #fff;
        --tw-ring-color: rgb(59 130 246 / 0.5);
        --tw-ring-offset-shadow: 0 0 #0000;
        --tw-ring-shadow: 0 0 #0000;
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        --tw-blur:  ;
        --tw-brightness:  ;
        --tw-contrast:  ;
        --tw-grayscale:  ;
        --tw-hue-rotate:  ;
        --tw-invert:  ;
        --tw-saturate:  ;
        --tw-sepia:  ;
        --tw-drop-shadow:  ;
        --tw-backdrop-blur:  ;
        --tw-backdrop-brightness:  ;
        --tw-backdrop-contrast:  ;
        --tw-backdrop-grayscale:  ;
        --tw-backdrop-hue-rotate:  ;
        --tw-backdrop-invert:  ;
        --tw-backdrop-opacity:  ;
        --tw-backdrop-saturate:  ;
        --tw-backdrop-sepia:  ;
      }
      
      ::backdrop{
        --tw-border-spacing-x: 0;
        --tw-border-spacing-y: 0;
        --tw-translate-x: 0;
        --tw-translate-y: 0;
        --tw-rotate: 0;
        --tw-skew-x: 0;
        --tw-skew-y: 0;
        --tw-scale-x: 1;
        --tw-scale-y: 1;
        --tw-pan-x:  ;
        --tw-pan-y:  ;
        --tw-pinch-zoom:  ;
        --tw-scroll-snap-strictness: proximity;
        --tw-gradient-from-position:  ;
        --tw-gradient-via-position:  ;
        --tw-gradient-to-position:  ;
        --tw-ordinal:  ;
        --tw-slashed-zero:  ;
        --tw-numeric-figure:  ;
        --tw-numeric-spacing:  ;
        --tw-numeric-fraction:  ;
        --tw-ring-inset:  ;
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-color: #fff;
        --tw-ring-color: rgb(59 130 246 / 0.5);
        --tw-ring-offset-shadow: 0 0 #0000;
        --tw-ring-shadow: 0 0 #0000;
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        --tw-blur:  ;
        --tw-brightness:  ;
        --tw-contrast:  ;
        --tw-grayscale:  ;
        --tw-hue-rotate:  ;
        --tw-invert:  ;
        --tw-saturate:  ;
        --tw-sepia:  ;
        --tw-drop-shadow:  ;
        --tw-backdrop-blur:  ;
        --tw-backdrop-brightness:  ;
        --tw-backdrop-contrast:  ;
        --tw-backdrop-grayscale:  ;
        --tw-backdrop-hue-rotate:  ;
        --tw-backdrop-invert:  ;
        --tw-backdrop-opacity:  ;
        --tw-backdrop-saturate:  ;
        --tw-backdrop-sepia:  ;
      }
      
      .fixed{
        position: fixed;
      }
      
      .bottom-0{
        bottom: 0px;
      }
      
      .left-0{
        left: 0px;
      }
      
      .table{
        display: table;
      }
      
      .h-12{
        height: 3rem;
      }
      
      .w-1\/2{
        width: 50%;
      }
      
      .w-full{
        width: 100%;
      }
      
      .border-collapse{
        border-collapse: collapse;
      }
      
      .border-spacing-0{
        --tw-border-spacing-x: 0px;
        --tw-border-spacing-y: 0px;
        border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
      }
      
      .whitespace-nowrap{
        white-space: nowrap;
      }
      
      .border-b{
        border-bottom-width: 1px;
      }
      
      .border-b-2{
        border-bottom-width: 2px;
      }
      
      .border-r{
        border-right-width: 1px;
      }
      
      .border-main{
        border-color: #5c6ac4;
      }
      
      .bg-main{
        background-color: #5c6ac4;
      }
      
      .bg-slate-100{
        background-color: #f1f5f9;
      }
      
      .p-3{
        padding: 0.75rem;
      }
      
      .px-14{
        padding-left: 3.5rem;
        padding-right: 3.5rem;
      }
      
      .px-2{
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
      
      .py-10{
        padding-top: 2.5rem;
        padding-bottom: 2.5rem;
      }
      
      .py-3{
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
      }
      
      .py-4{
        padding-top: 1rem;
        padding-bottom: 1rem;
      }
      
      .py-6{
        padding-top: 1.5rem;
        padding-bottom: 1.5rem;
      }
      
      .pb-3{
        padding-bottom: 0.75rem;
      }
      
      .pl-2{
        padding-left: 0.5rem;
      }
      
      .pl-3{
        padding-left: 0.75rem;
      }
      
      .pl-4{
        padding-left: 1rem;
      }
      
      .pr-3{
        padding-right: 0.75rem;
      }
      
      .pr-4{
        padding-right: 1rem;
      }
      
      .text-center{
        text-align: center;
      }
      
      .text-right{
        text-align: right;
      }
      
      .align-top{
        vertical-align: top;
      }
      
      .text-sm{
        font-size: 0.875rem;
        line-height: 1.25rem;
      }
      
      .text-xs{
        font-size: 0.75rem;
        line-height: 1rem;
      }
      
      .font-bold{
        font-weight: 700;
      }
      
      .italic{
        font-style: italic;
      }
      
      .text-main{
        color: #5c6ac4;
      }
      
      .text-neutral-600{
        color: #525252;
      }
      
      .text-neutral-700{
        color: #404040;
      }
      
      .text-slate-300{
        color: #cbd5e1;
      }
      
      .text-slate-400{
        color: #94a3b8;
      }
      
      .text-white{
        color: #fff;
      }
      
      @page {
        margin: 0;
      }
      
      @media print {
        body {
          -webkit-print-color-adjust: exact;
        }
      }      
      </style>
      <div>
        <div class="py-4">
            <div class="px-14 py-6">
                <table class="w-full border-collapse border-spacing-0">
                    <tbody>
                        <tr>
                            <td class="w-full align-top">
                                <div>
                                   Machucainvest SL
                                </div>
                            </td>

                            <td class="align-top">
                                <div class="text-sm">
                                    <table class="border-collapse border-spacing-0">
                                        <tbody>
                                            <tr>
                                                <td class="border-r pr-4">
                                                    <div>
                                                        <p class="whitespace-nowrap text-slate-400 text-right">Fecha</p>
                                                        <p class="whitespace-nowrap font-bold text-main text-right">${currentDate}</p>
                                                    </div>
                                                </td>
                                                <td class="pl-4">
                                                    <div>
                                                        <p class="whitespace-nowrap text-slate-400 text-right">Factura #</p>
                                                        <p class="whitespace-nowrap font-bold text-main text-right">${currentYear}-${cliente.id}</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="bg-slate-100 px-14 py-6 text-sm">
                <table class="w-full border-collapse border-spacing-0">
                    <tbody>
                        <tr>
                          <td class="w-1/2 align-top">
                              <div class="text-sm text-neutral-600">
                                <p class="font-bold">Datos de facturación del garaje</p>
                                <p>Dirección del garaje</p>
                                <p>7470 Madrid, España</p>
                                <p>CIF: A12345678</p>
                              </div>
                          </td>
                          <td class="w-1/2 align-top text-right">
                              <div class="text-sm text-neutral-600">
                                  <p class="font-bold">${cliente.nombre}</p>
                                  <p>${cliente.dfiscal}</p>
                                  <p>Madrid, España</p>
                                  <p>${cliente.dni}</p>
                              </div>
                          </td>
                      </tr>
                    </tbody>
                </table>
            </div>

            <div class="px-14 py-10 text-sm text-neutral-700">
                <table class="w-full border-collapse border-spacing-0">
                    <thead>
                        <tr>
                            <td class="border-b-2 border-main pb-3 pl-3 font-bold text-main">Artículo</td>
                            <td class="border-b-2 border-main pb-3 pl-2 font-bold text-main">Descripción</td>
                            <td class="border-b-2 border-main pb-3 pl-2 text-right font-bold text-main">Cantidad</td>
                            <td class="border-b-2 border-main pb-3 pl-2 text-center font-bold text-main">Precio</td>
                            <td class="border-b-2 border-main pb-3 pl-2 text-center font-bold text-main">% Dto.</td>
                            <td class="border-b-2 border-main pb-3 pl-2 text-right font-bold text-main">Total</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="border-b py-3 pl-3">ALQ001</td>
                            <td class="border-b py-3 pl-2">ARRENDAMIENTO GARAJE</td>
                            <td class="border-b py-3 pl-2 text-right">1,00</td>
                            <td class="border-b py-3 pl-2 text-center">${cliente.price} €</td>
                            <td class="border-b py-3 pl-2 text-center">0,00</td>
                            <td class="border-b py-3 pl-2 text-right">${cliente.price} €</td>
                        </tr>
                        <tr>
                          <td class="py-3 pl-3"></td>
                          <td class="py-3 pl-2"></td>
                          <td class="py-3 pl-2 text-right"></td>
                          <td class="py-3 pl-2 text-center"></td>
                          <td class="py-3 pl-2 text-center"></td>
                          <td class="py-3 pl-2 text-right"></td>
                        </tr>
                        <tr>
                          <td class="py-3 pl-3"></td>
                          <td class="py-3 pl-2"></td>
                          <td class="py-3 pl-2 text-right"></td>
                          <td class="py-3 pl-2 text-center"></td>
                          <td class="py-3 pl-2 text-center"></td>
                          <td class="py-3 pl-2 text-right"></td>
                        </tr>
                        <tr style="border: none !important">
                            <td colspan="6">
                                <table class="w-full border-collapse border-spacing-0">
                                    <tbody>
                                        <tr>
                                          <td class="w-full">
                                              <table class="w-full border-collapse border-spacing-0">
                                                <thead>
                                                  <tr>
                                                      <td class="border-b-2 border-main pb-3 pl-3 font-bold text-main"></td>
                                                      <td class="border-b-2 border-main pb-3 pl-2 font-bold text-main">Base Imponible</td>
                                                      <td class="border-b-2 border-main pb-3 pl-2 text-right font-bold text-main">IVA</td>
                                                      <td class="border-b-2 border-main pb-3 pl-2 text-center font-bold text-main">Importe IVA</td>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                  <tr>
                                                      <td class="border-b py-3 pl-3">NORMAL</td>
                                                      <td class="border-b py-3 pl-2">${(cliente.price/1.21).toFixed(2)} € </td>
                                                      <td class="border-b py-3 pl-2 text-right">21 %</td>
                                                      <td class="border-b py-3 pl-2 text-center">${((cliente.price/1.21)*0.21).toFixed(2)} € </td>
                                                      
                                                      <td style="visibility: hidden; border: none" class="border-b py-3 pl-2 text-center">0</td>
                                                      <td style="visibility: hidden; border: none" class="border-b py-3 pl-2 text-center">0</td>
                                                  </tr>
                                                  <tr style="visibility:hidden">
                                                    <td class=" py-3 pl-3">NORMAL</td>
                                                    <td class=" py-3 pl-2">${(cliente.price/1.21).toFixed(2)} € </td>
                                                    <td class=" py-3 pl-2 text-right">21 %</td>
                                                    <td class=" py-3 pl-2 text-center">${((cliente.price/1.21)*0.21).toFixed(2)} € </td>
                                                    
                                                    <td style="visibility: hidden; border: none" class="border-b py-3 pl-2 text-center">0</td>
                                                    <td style="visibility: hidden; border: none" class="border-b py-3 pl-2 text-center">0</td>
                                                </tr>
                                              </tbody>
                                              </table>
                                          </td>
                                          <td></td>
                                          <td class="w-full"></td>
                                            <td>
                                              <table class="w-full border-collapse border-spacing-0">
                                                  <tbody>
                                                      <tr>
                                                          <td class="border-b p-3">
                                                              <div class="whitespace-nowrap text-slate-400">Base Imponible:</div>
                                                          </td>
                                                          <td class="border-b p-3 text-right">
                                                              <div class="whitespace-nowrap font-bold text-main">${(cliente.price/1.21).toFixed(2)} € </div>
                                                          </td>
                                                      </tr>
                                                      <tr>
                                                          <td class="p-3">
                                                              <div class="whitespace-nowrap text-slate-400">IVA:</div>
                                                          </td>
                                                          <td class="p-3 text-right">
                                                              <div class="whitespace-nowrap font-bold text-main">${((cliente.price/1.21)*0.21).toFixed(2)} € </div>
                                                          </td>
                                                      </tr>
                                                      <tr>
                                                          <td class="bg-main p-3">
                                                              <div class="whitespace-nowrap font-bold text-white">Total:
                                                              </div>
                                                          </td>
                                                          <td class="bg-main p-3 text-right">
                                                              <div class="whitespace-nowrap font-bold text-white">${cliente.price.toFixed(2)} € </div>
                                                          </td>
                                                      </tr>
                                                  </tbody>
                                              </table>
                                          </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="px-14 text-sm text-neutral-700">
                <p class="text-main font-bold">Forma de pago</p>
                <p>Al contado</p>
                <p>1,00 Plazo/s</p>
                <p>0,00 Día/s</p>
            </div>

            <div class="px-14 py-10 text-sm text-neutral-700">
                <p class="text-main font-bold">Notas</p>
                <p class="italic">Arrendamiento Plaza de garaje 01/${currentMonth}/${currentYear} - 31/${currentMonth}/${currentYear}</p>
            </div>

            <footer class="fixed bottom-0 left-0 bg-slate-100 w-full text-neutral-600 text-center text-xs py-3">
                MADRID, ESPAÑA
                <span class="text-slate-300 px-2">|</span>
                RAZÓN SOCIAL GARAJE
                <span class="text-slate-300 px-2">|</span>
                CIF A12345678
            </footer>
        </div>
    </div>
    `;
    const filename = `factura.pdf`;

    const screenWidth = window.screen.availWidth;
    const screenHeight = window.screen.availHeight;
    const windowWidth = 900; // width of the print window
    const windowHeight = 900; // height of the print window
    const left = (screenWidth - windowWidth) / 2;
    const top = (screenHeight - windowHeight) / 2;

    const popupWin = window.open('', '_blank', `width=${windowWidth},height=${windowHeight},left=${left},top=${top}`);
    popupWin!.document.open();
    popupWin!.document.write(`
      <html>
      <head>
        <title>${filename}</title>
      </head>
      <body onload="window.print(); window.close()">
        ${htmlContent}
      </body>
      </html>
    `);
    popupWin!.document.close();
  }
  
  downloadHtmlInvoice(response: any) {
    console.log(response)
    const filename = `${response.filename}`;

    const screenWidth = window.screen.availWidth;
    const screenHeight = window.screen.availHeight;
    const windowWidth = 900; // width of the print window
    const windowHeight = 900; // height of the print window
    const left = (screenWidth - windowWidth) / 2;
    const top = (screenHeight - windowHeight) / 2;

    const popupWin = window.open('', '_blank', `width=${windowWidth},height=${windowHeight},left=${left},top=${top}`);
    popupWin!.document.open();
    popupWin!.document.write(`
      <html>
      <head>
        <title>${filename}</title>
      </head>
      <body onload="window.print(); window.close()">
        ${response.html}
      </body>
      </html>
    `);
    popupWin!.document.close();
  }

  async deleteItem(itemId, itemDBId) {
    const alert = await this.alert.create({
      header: '¿Borrar?',
      message: 'Borrar cliente con id: ' + itemId,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sí',
          handler: async () => {
            // console.log('Item to remove!!!');
            // this.rest.deleteClient();
            await this.deleteClient(itemDBId);
          }
        }
      ]
    });
    await alert.present();
  }

  async deleteClient(clientId: string) {
    try {
      const resp: any = await this.rest.deleteClientGaraje(clientId);
      console.log(resp);
      if (resp.ok) {
        await this.utils.showToast('Cliente eliminado con éxito', 'success');
        setTimeout(
          () => location.reload()
          , 500);
      }
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Error eliminando cliente', 'danger');
    }
  }

  addNew() {
    this.router.navigateByUrl('/garaje/new');
  }

  async llamarMailGun() {
    try{
      await this.utils.showLoading();
      const resp: any = await this.rest.sendFacturaGaraje();
      await this.utils.hideLoading();
      
      if (resp.ok) {
        await this.utils.showToast('Facturas enviadas con exito!', 'success');
      }
    }
    catch (error){
      console.log(error);
      await this.utils.showToast('Error al enviar las facturas', 'danger');
    }
  }

  async generateFacturaGaraje(line: ClientGaraje, data) {
    const body = {
      price: parseFloat(data.price),
      client: line,
      date: data.date
    }
    try{
      await this.utils.showLoading();
      const resp: any = await this.rest.generateFacturaGaraje(body);
      this.downloadHtmlInvoice(resp.body)
      await this.utils.hideLoading();
      
      if (resp.status === 201) {
        await this.utils.showToast('Factura generada con exito!', 'success');
      }
    }
    catch (error){
      console.log(error);
      await this.utils.showToast('Error al generar la factura', 'danger');
    }
  }


  pagination(event: any) {
    if ((this.currentPage + event >= 0) && (this.currentPage + event <= this.maxPage)) {
      this.currentPage += event;
    }
    console.log(this.currentPage);
    if (!this.searchMode) {
      this.getClientsGaraje();
    } else {
      this.search();
    }
  }

}
